import { CloseOutlined } from '@ant-design/icons';
import { ReactNode } from 'react';

import * as S from './styles';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  summary?: ReactNode;
  footer?: ReactNode;
  keepMounted?: boolean;
}

export default function BottomSheet({
  isOpen,
  onClose,
  title,
  children,
  summary,
  footer,
  keepMounted = false,
}: Props) {
  return (
    <S.Sheet
      visible={isOpen}
      onClose={onClose}
      placement="bottom"
      height="auto"
      closable={false}
      title={null}
      aria-label={title}
      destroyOnClose={!keepMounted}
      forceRender={keepMounted}
    >
      <S.Top>
        <S.Handle />
        <S.Header>
          <S.Heading>
            <S.Title>{title}</S.Title>
            {summary}
          </S.Heading>
          <S.CloseButton type="button" aria-label="Fechar" onClick={onClose}>
            <CloseOutlined aria-hidden />
          </S.CloseButton>
        </S.Header>
      </S.Top>
      <S.Content>{children}</S.Content>
      {footer && <S.Footer>{footer}</S.Footer>}
    </S.Sheet>
  );
}

export { Summary as SheetSummary } from './styles';
